import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { PmsManagementComponent } from './pms-management/pms-management.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MappingManagementComponent } from './dialogs/mapping-management/mapping-management.component';
import { FormsModule } from '@angular/forms';
import { ClientsModule } from '../clients-module/clients.module';
import { AddPmsUserComponent } from './dialogs/add-pms-user/add-pms-user.component';
import { SharedComponentsModule } from '../shared-components-module/shared-components.module';

const routes : Route[] = [
  { path: 'pms', component: PmsManagementComponent }
]

@NgModule({
    declarations: [MappingManagementComponent, AddPmsUserComponent],
    imports: [
        CommonModule,
        RouterModule.forRoot(routes),
        NgbModule,
        FormsModule,
        ClientsModule,
        SharedComponentsModule
    ]
})
export class PmsManagementModule { }
